export const MAX_PORTING_DATE_DAYS = 60;
